import { render } from "./gestordocumentos.vue?vue&type=template&id=0cfdd131"
import script from "./gestordocumentos.vue?vue&type=script&lang=js"
export * from "./gestordocumentos.vue?vue&type=script&lang=js"

import "./gestordocumentos.vue?vue&type=style&index=0&id=0cfdd131&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__